module.exports = __webpack_public_path__ + "img/logo-meghpakhi.f0f64461.png";